import React from "react";
import Footer from "../components/footer/Footer";

const FooterPage = () => {
  return (
    <>
      <Footer />
    </>
  );
};

export default FooterPage;
